import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import "./SplashScreen.css";

const SplashScreen = ({ onComplete }) => {
    const containerRef = useRef(null);
    const pathRef = useRef(null);
    const svgRef = useRef(null);
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        let shouldSkip = false;
        try {
            if (typeof window !== 'undefined' && window.sessionStorage) {
                shouldSkip = sessionStorage.getItem('skipSplash') === '1';
            }
        } catch (e) {
            shouldSkip = false;
        }

        if (shouldSkip) {
            try { sessionStorage.removeItem('skipSplash'); } catch (e) { /* ignore */ }
            setVisible(false);
            onComplete && onComplete();
            return () => {};
        }

        let savedScrollY = 0;
        let prevOverflow = '';
        let prevPosition = '';
        let prevTop = '';
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            savedScrollY = window.scrollY || window.pageYOffset || 0;
            prevOverflow = document.body.style.overflow;
            prevPosition = document.body.style.position;
            prevTop = document.body.style.top;

            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${savedScrollY}px`;
            document.body.style.width = '100%';
        }

        const tl = gsap.timeline({ defaults: { ease: "power1.out" } });
        const path = pathRef.current;
        const length = path.getTotalLength();

        gsap.set(path, {
            strokeDasharray: length,
            strokeDashoffset: length,
            fill: "transparent",
        });

        tl.to(path, { strokeDashoffset: 0, duration: 1.3 })
            .to(path, { fill: "#0F0F0F", duration: 0.8 }, "-=0.3");

        tl.to({}, { duration: 1 })
            .to(svgRef.current, { y: -20, opacity: 0, duration: 0.5 })
            .to(containerRef.current, { opacity: 0, duration: 0.5, onComplete: () => { setVisible(false); onComplete && onComplete(); } });

        return () => {
            tl.kill();
            if (typeof document !== 'undefined') {
                document.body.style.overflow = prevOverflow || '';
                document.body.style.position = prevPosition || '';
                document.body.style.top = prevTop || '';
                document.body.style.width = '';
                if (typeof window !== 'undefined') {
                    window.scrollTo(0, savedScrollY);
                }
            }
        };
    }, [onComplete]);

    if (!visible) return null;

    return (
        <div ref={containerRef} className="opening-screen">
            <div className="symbol-wrapper">
                <svg ref={svgRef} viewBox="0 0 262.7 262.7" preserveAspectRatio="xMidYMid meet">
                    <g>
                        <path
                            ref={pathRef}
                            stroke="#0F0F0F"
                            strokeWidth="2"
                            strokeMiterlimit="10"
                            d="m77.9 50.9-57.3 57.3 5 4.9 52.3-52.3 50.9 51v24.6H81.2v7.1h47.6v74.1L79.3 168H65.7v7h10.7l59.4 59.5v-91h38.1l-17.8 17.8-5 4.9 23.4 23.4 4.9-5-18.4-18.4 29.8-29.8h-55V112L187 60.9l52.2 52.2 4.9-4.9L187 51l-51.2 51.1V27.6h-7v74.2L77.9 50.9z"
                        />
                    </g>
                </svg>
            </div>
        </div>
    );
};

export default SplashScreen;
